import { useEffect } from "react";

export const useTrackUserLogin = (email: string | null, name: string | null) => {
    useEffect(() => {
        if (!window.umami) {
            console.error("Umami is not defined");
            return;
        }

        if (email) {
            window.umami.identify(email, { name: name || "", email });
        }
    }, [email, name]);
};
